<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     首页
  +---------------------------------------------------------------------------------------
-->

<template>
	<div class="home-index header-padding">
		<f-page-header />
		<el-scrollbar :native="false">
			<div class="flex justify-content-center" style="height: 100%">
				<div class="flex">
					<div class="left-area">
						<mpbar></mpbar>
						<phone-box :style="style.phoneBox" :designs="designs" :editing="formData.editing" @click="handleDesignClick"></phone-box>
						<el-popover placement="top" width="400" trigger="click" class="add-btn">
							<component-tabs :style="style.componentTabs" :components="components" @click="handleTabClick"></component-tabs>
							<div slot="reference">
								<el-button class="el-icon-plus" type="text">添加控件</el-button>
							</div>
						</el-popover>
					</div>

					<setting-box class="ml-lg" :style="style.settingBox" :editing="formData.editing" :formData="formData" :is_default="is_default" :designs="designs" :edit="!!$route.query.id" v-model="formData.title" @save="saveCase" @change="handleDesignClick"></setting-box>
				</div>
			</div>
		</el-scrollbar>
	</div>
</template>

<script>
import ComponentTabs from './components/ComponentTabs'
import Mpbar from './components/Mpbar.vue'
import PhoneBox from './components/PhoneBox'
import SettingBox from './components/SettingBox'
import TextPreview from './components/text/TextPreview'
import TextSetting from './components/text/TextSetting'
import MultTextPreview from './components/multtext/MultTextPreview'
import MultTextSetting from './components/multtext/MultTextSetting'
import TipsPreview from './components/tips/TipsPreview'
import TipsSetting from './components/tips/TipsSetting'
import SelectorPreview from './components/selector/SelectorPreview'
import SelectorSetting from './components/selector/SelectorSetting'
import AttachPreview from './components/attach/AttachPreview'
import AttachSetting from './components/attach/AttachSetting'

import { postSchmeApi, getSchemeApi } from '@/api/qc/schemeApi'
import { ssidv1 } from '@/utils/common'
export default {
	name: 'QcSchemedetail',

	components: {
		ComponentTabs,
		PhoneBox,
		SettingBox,
		Mpbar
	},

	data () {
		return {
			screenHeight: 0,
			screenWidth: 0,
			modules: [],
			is_default: 0,
			components: {
				basics: [
					{
						control: 'Text',
						name: '文本',
						icon: 'iconfont icon-text',
						type: 1,
						preview: TextPreview,
						setting: {
							component: TextSetting
						},
						data: {
							title: '文本',
							placeholder: '请输入',
							require: 0
						}
					},
					{
						control: 'MultText',
						name: '多行文本',
						icon: 'iconfont icon-multtext',
						type: 2,
						preview: MultTextPreview,
						setting: {
							component: MultTextSetting
						},
						data: {
							title: '多行文本',
							placeholder: '请输入',
							require: 0
						}
					},
					{
						control: 'Number',
						name: '数字',
						icon: 'iconfont icon-number',
						type: 3,
						preview: TextPreview,
						setting: {
							component: TextSetting
						},
						data: {
							title: '数字',
							placeholder: '请输入',
							require: 0
						}
					},
					{
						control: 'Amount',
						name: '金额',
						icon: 'iconfont icon-amount',
						type: 4,
						preview: TextPreview,
						setting: {
							component: TextSetting
						},
						data: {
							title: '金额',
							placeholder: '请输入',
							require: 0
						}
					},
					{
						control: 'Date',
						name: '日期',
						icon: 'iconfont icon-date',
						type: 5,
						preview: TextPreview,
						setting: {
							component: TextSetting
						},
						data: {
							title: '日期',
							placeholder: '请输入',
							require: 0
						}
					},
					{
						control: 'Time',
						name: '日期 + 时间',
						icon: 'iconfont icon-datetime',
						type: 6,
						preview: TextPreview,
						setting: {
							component: TextSetting
						},
						data: {
							title: '日期 + 时间',
							placeholder: '请输入',
							require: 0
						}
					},
					{
						control: 'Tips',
						name: '说明控件',
						icon: 'el-icon-document',
						type: 7,
						preview: TipsPreview,
						setting: {
							component: TipsSetting
						},
						data: {
							title: '说明控件'
						}
					},
					{
						control: 'Selector',
						name: '单选',
						icon: 'iconfont icon-singleselect',
						type: 8,
						preview: SelectorPreview,
						setting: {
							type: 'single',
							component: SelectorSetting
						},
						data: {
							title: '单选',
							placeholder: '请选择',
							options: [
								{
									key: 'option-' + ssidv1(),
									title: '选项A'
								},
								{
									key: 'option-' + ssidv1(),
									title: '选项B'
								}
							],
							op_relations: [],
							require: 0
						}
					},
					{
						control: 'Selector',
						name: '多选',
						icon: 'iconfont icon-multselect',
						type: 9,
						preview: SelectorPreview,
						setting: {
							type: 'multi',
							component: SelectorSetting
						},
						data: {
							title: '多选',
							placeholder: '请选择',
							options: [
								{
									key: 'option-' + ssidv1(),
									title: '选项A'
								},
								{
									key: 'option-' + ssidv1(),
									title: '选项B'
								},
								{
									key: 'option-' + ssidv1(),
									title: '选项C'
								}
							],
							op_relations: [],
							require: 0
						}
					},
					{
						control: 'Attachment',
						name: '附件',
						icon: 'iconfont icon-attach',
						type: 10,
						preview: AttachPreview,
						setting: {
							component: AttachSetting
						},
						data: {
							title: '附件',
							placeholder: '',
							require: 0,
							phonelimit: 0
						}
					}
				]
			},
			// 用户正在编辑的网站数据
			designs: [],
			// 设置项
			formData: {
				title: '',
				editing: null
			}
		}
	},

	computed: {
		style: function () {
			return {
				componentTabs: {
					float: 'left',
					width: '380px',
					height: '100%',
					overflow: 'hidden'
				},
				phoneBox: {
					float: 'left',
					width: 375 + 'px'
				},
				settingBox: {
					float: 'right',
					width: '776px',
					height: '100%',
					overflow: 'auto'
				}
			}
		}
	},

	created () {
		this.fetchData()
	},
	mounted: function () {
		const onResize = () => {
			this.screenHeight = document.body.clientHeight - 60
			this.screenWidth = document.body.clientWidth
		}
		onResize()
		window.addEventListener('resize', onResize, false)
	},

	methods: {
		fetchData () {
			if (this.$route.query.id) {
				getSchemeApi({ schemeid: this.$route.query.id }).then(res => {
					if (!res.errno) {
						this.is_default = res.data.is_default
						this.formData.schemeid = this.$route.query.id
						this.formData.title = res.data.scheme_title
						res.data.form.forEach(item => {
							let component = Object.assign({}, this.components.basics[item.type - 1])
							component.data = item
							let designData = {
								type: component.type,
								name: component.name,
								preview: component.preview,
								setting: component.setting,
								comfirm: false,
								id: item.id,
								data: {
									// 深度复制
									...JSON.parse(JSON.stringify(component.data))
								}
							}
							this.designs.push(designData)
							this.formData.editing = designData
						})
					}
				})
			}
		},

		handleTabClick: function (component) {
			let id = 'control-' + ssidv1()
			let designData = {
				type: component.type,
				name: component.name,
				preview: component.preview,
				setting: component.setting,
				comfirm: false,
				id: id,
				data: {
					id: id,
					type: component.type,
					// 深度复制
					...JSON.parse(JSON.stringify(component.data))
				}
			}
			this.designs.push(designData)
			this.formData.editing = designData
		},

		handleDesignClick: function (designData, value) {
			if (designData) designData['comfirm'] = value
			this.formData.editing = designData
		},

		// handleSaveClick: function () {
		//   console.log(JSON.stringify(this.designs.map(({ data }) => ({ ...data }))))
		// },
		//提交质检方案
		saveCase () {
			let data = { scheme_title: this.formData.title, form: JSON.parse(JSON.stringify(this.designs.map(({ data }) => ({ ...data })))) }
			if (this.formData.schemeid) {
				data['schemeid'] = this.formData.schemeid
			}
			postSchmeApi(data).then(res => {
				if (!res.errno) {
					this.$message.success(res.message)
					this.$router.push('/qc/scheme')
				} else {
					this.$message.error(res.message)
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.home-index {
	position: relative;
	.left-area {
		position: relative;
		height: 812px;
		.add-btn {
			position: absolute;
			background: #fff;
			width: 100%;
			height: 84px;
			border-radius: 0px 0px 24px 24px;
			text-align: center;
			bottom: 0px;
			left: 0;
			z-index: 100;
		}
	}
}
</style>
